import React from 'react';
import ListItem from './_ListItem';

const Lista = ({ type, value }) => {
  const style = require('./Lista.scss');
  return (
    <div className={style[type]}>
      <ul className={style.ul}>
        {value.map((val, i) =>
          <ListItem value={val} key={i}/>
        )}
      </ul>
    </div>
  );
};

export default Lista;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Lista/Lista.js
 **/